(() => {
  'use strict';
  if (window.TotfCollectionIntentions) return;
  // Match actual title/type/tag words. Sparse metadata may produce no matches.
  const themes = {
    celestial: ['celestial', 'moon', 'star', 'stars', 'starlit', 'cosmic', 'astrology', 'zodiac'],
    'shadow-work': ['shadow', 'gothic', 'dark'],
    metallic: ['embossed', 'metallic', 'sacred', 'geometry', 'hexagram', 'bronze'],
    nature: ['nature', 'forest', 'botanical', 'celtic', 'animal', 'animals', 'fairy', 'fae', 'ocean', 'floral'],
    love: ['romance', 'romantic', 'love', 'relationship', 'relationships', 'selfcare'],
    art: ['art', 'nouveau', 'visionary', 'psychedelic', 'watercolor'],
    beginner: ['beginner', 'beginners', 'daily', 'clarity', 'guidebook']
  };
  const path = url => url.pathname.replace(/\/$/, '');
  const words = text => new Set(text.toLowerCase().normalize('NFKC').split(/[^\p{L}\p{N}]+/u).filter(Boolean));
  function sync() {
    const current = new URL(window.location.href);
    let activeTheme = null;
    let message = '';
    document.querySelectorAll('[data-collection-intentions]').forEach(root => {
      const links = [...root.querySelectorAll('[data-intention-link]')];
      const entries = links.map(link => ({ link, url: new URL(link.href, current) }));
      const selected = entries.find(({ url }) => url.origin === current.origin && path(url) === path(current) && url.searchParams.size > 0 && [...url.searchParams].every(([key, value]) => current.searchParams.get(key) === value))
        || (!current.searchParams.get('filter') ? entries.find(({ url }) => url.origin === current.origin && path(url) === path(current) && !url.searchParams.size) : null);
      entries.forEach(({ link }) => {
        const active = link === selected?.link;
        link.classList.toggle('is-active', active);
        if (active) link.setAttribute('aria-current', 'page'); else link.removeAttribute('aria-current');
      });
      const key = selected?.url.searchParams.get('filter');
      if (key && Object.hasOwn(themes, key)) { activeTheme = themes[key]; message = root.dataset.emptyMessage; }
    });
    // The bar is reusable navigation elsewhere; only this deck catalog is enhanced.
    document.querySelectorAll('[data-deck-matcher] .dm-catalog').forEach(catalog => {
      let visible = 0;
      catalog.querySelectorAll('.dm-grid > [data-deck-keywords]').forEach(card => {
        const tokens = words(card.dataset.deckKeywords);
        card.hidden = Boolean(activeTheme && !activeTheme.some(token => tokens.has(token)));
        if (!card.hidden) visible++;
      });
      const count = catalog.querySelector('[data-deck-count]');
      if (count) count.textContent = count.dataset.countTemplate.replace('INTENTION_COUNT', String(visible));
      const empty = catalog.querySelector('[data-deck-intention-empty]');
      if (empty) { empty.hidden = !activeTheme || visible > 0; empty.textContent = message; }
    });
  }
  window.TotfCollectionIntentions = { sync };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, { once: true });
  else sync();
  window.addEventListener('pageshow', sync);
  window.addEventListener('popstate', sync);
  document.addEventListener('shopify:section:load', sync);
  document.addEventListener('shopify:section:reorder', sync);
  document.addEventListener('shopify:section:unload', event => {
    // Shopify removes the section after dispatching the unload event.
    if (event.target.querySelector('[data-collection-intentions]')) window.setTimeout(sync, 0);
  });
})();
